var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{attrs:{"to":_vm.link}},[_c('i',{staticClass:"far fa-arrow-alt-circle-left"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }